import request from '@/utils/request'

export function getCommonMajor(searchParams, isNotify) {
  return request({
    url: `/api/getCommonMajor`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data : searchParams,
    Notify: { use: isNotify, apitype: 'searched' }
  })
}

export function getCommonMinor(searchParams, isNotify) {
  return request({
    url: `/api/getCommonMinor`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data : searchParams,
    Notify: { use: isNotify, apitype: 'searched' }
  })
}

export function saveCommonManage(params, isNotify) {
  return request({
    url: `/api/saveCommonManage`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data : params,
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}

export function deleteCommonManage(params, isNotify){
  return request({
    url:'/api/deleteCommonManage',
    method:'POST',
    meta:{apiVersion:'1.0.0'},
    headers:{ 'Content-Type': 'application/json;charset=utf8' },
    data : params,
    Notify: { use: isNotify, apitype: 'deleted' } //searched, saved,deleted
  })
}